import { render, staticRenderFns } from "./AdminActivityWidget.vue?vue&type=template&id=796576a4&scoped=true&"
import script from "./AdminActivityWidget.vue?vue&type=script&lang=js&"
export * from "./AdminActivityWidget.vue?vue&type=script&lang=js&"
import style0 from "./AdminActivityWidget.vue?vue&type=style&index=0&id=796576a4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "796576a4",
  null
  
)

export default component.exports